import { useState } from 'react'

import { Button, Text } from '@factorialco/deprecated-design-system'
import { List } from '@factorialco/deprecated-design-system'
import {
  CompensationsPayrollConceptFragment,
  PayrollValueObjectsConceptCategoryEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import AddConceptModal from 'modules/compensations/pages/settings/PayrollConcepts/AddConceptModal'
import ConceptBlock from 'modules/compensations/pages/settings/PayrollConcepts/ConceptBlock'
import {
  UNCATEGORIZED_CATEGORY,
  payrollConceptCategoriesLabels,
} from 'modules/payroll_bundle/lib/constants'

interface CategoryBlockProps {
  category: PayrollValueObjectsConceptCategoryEnum | typeof UNCATEGORIZED_CATEGORY
  concepts: CompensationsPayrollConceptFragment[]
  legacyPayroll?: boolean
}

const CategoryBlock = ({ category, concepts, legacyPayroll = false }: CategoryBlockProps) => {
  const [showAddModal, setShowAddModal] = useState<boolean>(false)

  const enableCreate = category !== UNCATEGORIZED_CATEGORY
  const label = enableCreate
    ? payrollConceptCategoriesLabels()[category]
    : i18n.t('compensations.settings.concepts.uncategorized')

  const onClick = () => {
    setShowAddModal(true)
  }

  return (
    <>
      <List.Item key={category}>
        <List.Title>
          <Text.Normal color="grey1000" weight="semibold">
            {label}
          </Text.Normal>
        </List.Title>
        {enableCreate && (
          <List.ActionItem>
            <Button type="secondary" iconName="add" onClick={onClick}></Button>
          </List.ActionItem>
        )}
      </List.Item>
      {concepts.length > 0 &&
        concepts.map((concept) => (
          <ConceptBlock concept={concept} key={concept.id} legacyPayroll={legacyPayroll} />
        ))}
      {enableCreate && showAddModal && (
        <AddConceptModal
          category={category}
          onSuccess={() => setShowAddModal(false)}
          onClose={() => setShowAddModal(false)}
          legacyPayroll={legacyPayroll}
        />
      )}
    </>
  )
}

export default CategoryBlock
